export const typeDropdown = () => [
  { id: 1, description: 'Proof of Identity (e.g., government-issued ID, SSN)' },
  { id: 2, description: 'Proof of Address (e.g., utility bills, bank statements)' },
  { id: 3, description: 'PendingSubmission Forms' },
  { id: 4, description: 'Property Information (e.g., home purchase agreement, property tax bill)' },
  { id: 5, description: 'Medical Records (e.g., medical history, doctor’s reports)' },
  { id: 6, description: 'Income PendingSubmission (e.g., pay stubs, tax returns, bank statements)' },
  { id: 7, description: 'Other' },
];
